/* eslint-disable valid-jsdoc */
import baseRoute from "@/router/baseRoute";
import fullpath from "@/router/fullpath";

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
    if (route.meta && route.meta.roles) {
        // console.log(route, roles);
        return roles.some(role => route.meta.roles.indexOf(role) >= 0);
    }
    return true;
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param fullList
 * @param roles
 */
function filterAsyncRouter(fullList, roles) {
    const accessedRouters = fullList.filter(route => {
        if (hasPermission(roles, route)) {
            if (route.children && route.children.length) {
                route.children = filterAsyncRouter(route.children, roles);
                // console.log(route.children);
            }
            return true;
        }
        return false;
    });
    return accessedRouters;
}

const permission = {
    state: {
        routers: baseRoute,
        // addRouters: JSON.parse(sessionStorage.getItem("addRouters")) || []
        addRouters: []
    },
    mutations: {
        SET_ROUTERS: (state, routers) => {
            state.addRouters = routers;
            // window.sessionStorage.setItem(
            //     "addRouters",
            //     JSON.stringify(routers)
            // );
            state.routers = baseRoute.concat(routers);
        },
        DEL_ROUTERS: state => {
            state.routers = baseRoute;
            state.addRouters = [];
        }
    },
    actions: {
        GenerateRoutes({ commit }, data) {
            return new Promise(resolve => {
                const { roles } = data;
                // console.log(roles);
                var fullList = fullpath.concat();
                let accessedRouters;
                if (roles.indexOf("main") >= 0) {
                    accessedRouters = fullList;
                } else {
                    accessedRouters = filterAsyncRouter(fullList, roles);
                }
                commit("SET_ROUTERS", accessedRouters);
                resolve();
            });
        },
        DelRoutes({ commit }) {
            return new Promise(resolve => {
                commit("DEL_ROUTERS");
                resolve();
            });
        }
    }
};

export default permission;
